export default __webpack_public_path__ + "static/media/cancel_visit_icon.e1d8c750.svg";